(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/views/empty_desktop.js') >= 0) return;  svs.modules.push('/modules/tipset/views/empty_desktop.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.tipset=_svs.tipset||{};
_svs.tipset.templates=_svs.tipset.templates||{};
svs.tipset.templates.empty = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options;

  stack1 = ((helper = (helper = helpers.isMobile || (depth0 != null ? depth0.isMobile : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"isMobile","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!helpers.isMobile) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { return stack1; }
  else { return ''; }
},"2":function(container,depth0,helpers,partials,data) {
    return "";
},"4":function(container,depth0,helpers,partials,data) {
    return "\n      <div id=\"tipset-betslipoverview-dimmer\" class=\"tipset-betslipoverview-dimmer\"></div>\n    ";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div id=\"startpage\"></div>\n<div class=\"tipset-play\">\n    "
    + ((stack1 = (helpers.feature || (depth0 && depth0.feature) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ft-betslip",{"name":"feature","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(2, data, 0),"data":data})) != null ? stack1 : "")
    + "\n    <div id=\"game\"></div>\n    <div class=\"clearfix\"></div>\n    <div class=\"col-sm12 single-rows\" id=\"single-rows\"></div>\n</div>\n";
},"useData":true});
Handlebars.partials['svs-tipset-empty'] = svs.tipset.templates.empty;
})(svs, Handlebars);

 })(window);